$(function() {

    const headerSlider = $(".header__slider").flickity({
        wrapAround : true,
        pageDots : false,
        prevNextButtons : false,
        draggable: false,
        bgLazyLoad: true
    })    

    $(".header__slider .flickity-control span").on("click", function() {
        flickityControl($(this), headerSlider);           
    })

})